import { share, take } from 'rxjs';
import { BaseItemService } from './base-item-service';
import { ClientCacheRequestMode } from '../../client-cache';
/**
 * SimpleItemService will fetch all items at once.
 */
// not injected, use ItemServiceFactory/CrudServiceFactory to create!
export class SimpleItemService extends BaseItemService {
  refreshAllItems() {
    if (!this.hasReadItems) return;
    // already has this.query assigned! no need to use withCustomQuery!
    const req = this.crud.readManyWithRangeInfo({
      cache: ClientCacheRequestMode.wipeCache
    }).pipe(take(1), share());
    req.subscribe(chunk => {
      this.updateItemListAndRange(chunk.items, chunk.rangeInfo);
    });
    return req;
  }
  _readItems() {
    this.assertInitialized();
    if (this.hasReadItems) return;
    this.hasReadItems = true;
    // already has this.query assigned! no need to use withCustomQuery!
    this.crud.readManyWithRangeInfo().subscribe(chunk => {
      this.updateItemListAndRange(chunk.items, chunk.rangeInfo);
    });
  }
}